export default __webpack_public_path__ + "static/media/320.4474bfb0.png";